<template>
    <v-container fluid>
        <!-- Breadcrumbs -->
        <v-breadcrumbs
            :items="[
                { text: 'Home', disable: false, href: '/#/' },
                { text: 'Products', disable: false, href: '/#/products' },
                { text: 'Settings', disabled: true }
            ]"
            divider="/"
        ></v-breadcrumbs>

        <!-- Product Category Dialog -->
        <ProductCategoryEditDialog
            :dialog.sync="productCategoryDialog"
            :object.sync="editedProductCategory"
            v-on:item-created="productCategoryAdded"
        ></ProductCategoryEditDialog>

        <!-- Delete Supplier Dialog -->
        <DeleteDialog
            :dialog.sync="deleteDialog"
            :item="deletedItem"
            v-on:confirmed="deletingConfirmed"
        >
            <template v-slot:title
                >Delete - {{ deletedItem ? deletedItem.name : "" }}</template
            >
            <template v-slot:content
                >Are you sure you want to delete this
                {{ deletedItem.type }}?</template
            >
        </DeleteDialog>

        <v-card class="mx-3 elevation-5">
            <v-tabs centered show-arrows>
                <v-tabs-slider color="primary"></v-tabs-slider>

                <!-- tab header -->
                <v-tab>
                    <v-icon left>collections_bookmark</v-icon>Product Category
                </v-tab>

                <!-- tab body -->
                <!-- Product Category -->
                <v-tab-item>
                    <v-card flat>
                        <v-card-title class="pb-0">
                            <v-col cols="12" sm="3"></v-col>

                            <v-spacer></v-spacer>
                            <v-col cols="12" sm="6" class="pl-9">
                                <v-text-field
                                    dense
                                    v-model="searchProductCategory"
                                    append-outer-icon="refresh"
                                    @click:append-outer="
                                        refreshProductCategoryCurrentPage()
                                    "
                                    label="Search"
                                    clearable
                                    hide-details
                                    class="mx-2"
                                    @keydown.enter="
                                        refreshProductCategoryCurrentPage()
                                    "
                                    @click:clear="
                                        onClearProductCategorySearch()
                                    "
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-btn
                                    color="primary"
                                    outlined
                                    rounded
                                    small
                                    class="mx-2 float-right"
                                    @click="addProductCategory()"
                                    >Add</v-btn
                                >
                            </v-col>
                        </v-card-title>

                        <v-container fluid>
                            <v-data-table
                                :headers="productCategoryHeaders"
                                :loading="
                                    $apollo.queries.tenantProductCategories
                                        .loading
                                "
                                :items="productCategory"
                                :options.sync="productCategoryDataTableOptions"
                                :server-items-length="
                                    tenantProductCategories.totalCount
                                "
                                loading-text="Loading... Please wait"
                                :items-per-page="defaultItemsPerPage"
                                :footer-props="{
                                    'items-per-page-options': [
                                        10,
                                        25,
                                        50,
                                        75,
                                        100
                                    ],
                                    'disable-pagination':
                                        $apollo.queries.tenantProductCategories
                                            .loading
                                }"
                            >
                                <template v-slot:item.action="{ item }">
                                    <v-btn
                                        v-if="
                                            hasPermission(
                                                'change_productcategory'
                                            )
                                        "
                                        outlined
                                        fab
                                        x-small
                                        color="primary"
                                        class="mr-2"
                                        @click="editProductCategory(item.node)"
                                    >
                                        <v-icon>edit</v-icon>
                                    </v-btn>
                                    <v-btn
                                        v-if="
                                            hasPermission(
                                                'delete_productcategory'
                                            )
                                        "
                                        outlined
                                        fab
                                        x-small
                                        :disabled="
                                            item.node.productSet.totalCount > 0
                                        "
                                        color="error"
                                        @click="
                                            deletingProductCategory(item.node)
                                        "
                                    >
                                        <v-icon>delete</v-icon>
                                    </v-btn>
                                    <!-- <v-icon small @click="deletingProduct(item)">delete</v-icon> -->
                                </template>
                            </v-data-table>
                        </v-container>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </v-card>
    </v-container>
</template>

<script>
import gql from "graphql-tag";
import helper from "@/utils/helper.js";
import ProductCategoryEditDialog from "@/components/products/ProductCategoryEditDialog.vue";
import DeleteDialog from "@/components/base/DeleteDialog.vue";

export default {
    name: "product-settings-page",
    components: {
        ProductCategoryEditDialog,
        DeleteDialog
    },

    apollo: {
        tenantProductCategories: {
            query: gql`
                query tenantProductCategories(
                    $first: Int
                    $last: Int
                    $before: String
                    $after: String
                    $orderBy: String
                    $search: String
                ) {
                    tenantProductCategories(
                        first: $first
                        last: $last
                        before: $before
                        after: $after
                        search: $search
                        orderBy: $orderBy
                    ) {
                        edgeCount
                        totalCount
                        pageInfo {
                            startCursor
                            endCursor
                            hasPreviousPage
                            hasNextPage
                        }
                        edges {
                            node {
                                id
                                name
                                printPriority
                                productSet {
                                    totalCount
                                }
                            }
                        }
                    }
                }
            `,
            variables() {
                return {
                    first: 10
                };
            },
            // Additional options here
            fetchPolicy: "cache-and-network",
            update: (data) => data.tenantProductCategories,
            skip: false,
            pollInterval: 60000 // ms
        }
    },

    data: function () {
        return {
            // isLoadingInventory: false,

            productCategoryDialog: false,
            colorDialog: false,
            tagDialog: false,
            environmentDialog: false,
            potSizeDialog: false,
            deleteDialog: false,
            searchProductCategory: "",
            searchPotSize: "",
            searchColor: "",
            searchEnvironment: "",
            searchTag: "",

            defaultItemsPerPage: 25,
            productCategoryDataTableOptions: {},
            page: 1,

            tenantProductCategories: {},

            // deleted item
            deletedItem: {
                id: null,
                type: null,
                name: null
            },

            // edited item
            editedProductCategory: {},

            // table headers
            productCategoryHeaders: [
                {
                    text: "Product Category",
                    value: "node.name",
                    sortable: true
                },
                {
                    text: "Print Priority",
                    value: "node.printPriority",
                    sortable: true
                },
                {
                    text: "#Products",
                    value: "node.productSet.totalCount",
                    sortable: false
                },
                {
                    text: "Action",
                    align: "center",
                    value: "action",
                    width: "120px",
                    sortable: false
                }
            ]
        };
    },
    computed: {
        // inventory: function() {
        //     return this.$store.state.inventory.inventory;
        // }
        productCategory() {
            return this.tenantProductCategories
                ? this.tenantProductCategories.edges
                : [];
        }
    },
    watch: {
        productCategoryDataTableOptions: {
            handler() {
                this.refreshProductCategoryCurrentPage();
            },
            deep: true
        }
    },
    created() {
        this.hasPermission = helper.hasPermission;
    },
    methods: {
        // product category
        addProductCategory() {
            this.editedProductCategory = null;
            this.productCategoryDialog = true;
        },
        productCategoryAdded() {
            this.$apollo.queries.tenantProductCategories.refresh();
        },
        editProductCategory(productCategory) {
            this.editedProductCategory = JSON.parse(
                JSON.stringify(productCategory)
            );
            this.productCategoryDialog = true;
        },
        deletingProductCategory(item) {
            this.deletedItem.type = "product category";
            this.deletedItem.id = item.id;
            this.deletedItem.name = item.name;
            this.deleteDialog = true;
        },

        // delete confirmed
        deletingConfirmed() {
            switch (this.deletedItem.type) {
                case "product category":
                    this.callDeleteProductCategory();
                    break;
                default:
                    return;
            }
        },

        callDeleteProductCategory() {
            if (this.deletedItem) {
                const payload = {
                    id: this.deletedItem.id
                };

                this.$store
                    .dispatch(
                        "productCategories/deleteProductCategory",
                        payload
                    )
                    .then((response) => {
                        // refresh products
                        this.$apollo.queries.tenantProductCategories.refresh();

                        // close delete dialog
                        this.deleteDialog = false;

                        // show snackbar
                        const payload = {
                            color: "success",
                            message: `${response.name} is deleted!`
                        };
                        this.$store.dispatch("snackbar/showMessage", payload);
                    })
                    .catch((error) => {
                        this.error = error.graphQLErrors[0].message;
                    });
            }
        },

        refreshProductCategoryCurrentPage() {
            const {
                sortBy,
                sortDesc,
                page,
                itemsPerPage
            } = this.productCategoryDataTableOptions;

            // console.log(this.productCategoryDataTableOptions);

            var _first = itemsPerPage;
            var _last = null;
            var _before = null;
            var _after = null;
            var _orderBy = null;

            if (page < this.page) {
                _first = null;
                _last = itemsPerPage;
                _before = this.tenantProductCategories.pageInfo.startCursor;
                _after = null;
            }

            if (page > this.page) {
                _first = itemsPerPage;
                _last = null;
                _before = null;
                _after = this.tenantProductCategories.pageInfo.endCursor;
            }

            switch (sortBy[0]) {
                case "node.name":
                    _orderBy = "name";
                    break;
                case "node.printPriority":
                    _orderBy = "printPriority";
                    break;
                default:
                    _orderBy = null;
                    break;
            }

            if (sortDesc[0] === true) {
                _orderBy = "-" + _orderBy;
            }

            this.$apollo.queries.tenantProductCategories.setVariables({
                first: _first,
                last: _last,
                before: _before,
                after: _after,
                orderBy: _orderBy,
                search: this.searchProductCategory
            });

            // set skip false to execute the query
            this.$apollo.queries.tenantProductCategories.skip = false;
            this.$apollo.queries.tenantProductCategories.refresh();

            // update this.page
            this.page = page;
        },

        onClearProductCategorySearch() {
            this.searchProductCategory = "";

            this.refreshProductCategoryCurrentPage();
        }
    }
};
</script>